import React, { useState } from 'react';

import { Collapse, makeStyles, Paper } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp, Close } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  cajaTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  close: {
    borderRadius: '100%',
    backgroundColor: 'red',
    color: 'white',
    cursor: 'pointer',
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginLeft: 10
  },
  title: {
    width: '100%',
    fontSize: 18,
    fontWeight: 'bold',
    background: 'red',
    color: 'white',
    padding: '6px',
    borderRadius: '20px',
    marginBottom: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    margin: theme.spacing(1),
    overflow: 'auto'
  },
  container: {
    padding: 10,
    border: '1px solid red',
    borderRadius: 10,
    marginTop: '15px',
    width: '100%'
  }
}));

export default function CollapseData({ title, children, close }) {
  const classes = useStyles();
  const [display, setDisplay] = useState(true);
  return (
    <div className={classes.container}>
      <div className={classes.cajaTitle}>
        <div className={classes.title} onClick={() => setDisplay(!display)}>
          <span>{title}</span>
          {display ? <ArrowDropUp /> : <ArrowDropDown />}
        </div>
        <div className={classes.close} onClick={close}>
          <Close style={{ fontSize: 26 }} />
        </div>
      </div>
      <Collapse in={display}>
        <Paper elevation={4} className={classes.paper}>
          {children}
        </Paper>
      </Collapse>
    </div>
  );
}
